import styled from 'styled-components';
import { isMobile } from 'utils';

export const LoginForgotPassword = styled.h4`
  display: inline;
  cursor: pointer;
  color: var(--v3-text-color);
  font-size: 14px;
  font-weight: 400;
  line-height: 16px;
  text-align: right;
  float: right;
  margin: 0;
`;

export const LoginInfoBlock = styled.div`
  color: var(--v3-text-color-secondary);
  font-size: 15px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: -0.32px;
`;

export const LoginInfoSignUp = styled.span`
  cursor: pointer;
  color: var(--v3-text-color);
  font-size: 15px;
  text-decoration: underline;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: -0.32px;
  white-space: nowrap;
`;

export const LoginBodySpace = styled.div`
  padding-top: ${isMobile() ? '80px' : '120px'};
`;
